export default __webpack_public_path__ + "static/media/bp-logo-white.c253cfc6.png";